import { render, staticRenderFns } from "./BaseArticleTextRow.vue?vue&type=template&id=7f94b11a&scoped=true&"
import script from "./BaseArticleTextRow.vue?vue&type=script&lang=js&"
export * from "./BaseArticleTextRow.vue?vue&type=script&lang=js&"
import style0 from "./BaseArticleTextRow.vue?vue&type=style&index=0&id=7f94b11a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f94b11a",
  null
  
)

export default component.exports